export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  grade: number
  page_count: number
  kind: number
  allot: number
  name: string
  subject_id: number
  subject_name: string
  field_names_completed: boolean
  corretct_image_completed: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.grade = sheet.grade;
    this.page_count = sheet.page_count;
    this.kind = sheet.kind;
    this.allot = sheet.allot;
    this.name = sheet.name;
    this.subject_id = sheet.subject_id;
    this.subject_name = sheet.subject_name;
    this.field_names_completed = sheet.field_names_completed;
    this.corretct_image_completed = sheet.corretct_image_completed;
  }
}

export class ScoreRateHeaderItem {
  room_name: string
  count: number

  constructor(room_name: string, count: number){
    this.room_name = room_name == "全体" ? room_name : `${room_name}組`;
    this.count = count;
  }
}

export class ScoreRateItem {
  room_name: string
  score_rate: number

  constructor(room_name: string, score_rate: number){
    this.room_name = room_name;
    this.score_rate = score_rate;
  }
}

export class ScoreRateRoomItem {
  room_name: string
  count: number
  per: number

  constructor(room_name: string, perFrom: number, perTo: number, scoreRateItems: ScoreRateItem[]){
    this.room_name = room_name;
    this.count = scoreRateItems.filter(x => x.score_rate >= perFrom && x.score_rate <= perTo).length;
    this.per = Math.round(this.count / scoreRateItems.length * 1000) / 10;
  }
}

export class ScoreRateRowItem {
  thColumn: string
  tdColumns: any[] = new Array<any>();

  constructor(rateFrom: number, rateTo: number, scoreRateRoomItems: ScoreRateRoomItem[]){
    this.thColumn =`${rateFrom}〜${rateTo}％`;
    scoreRateRoomItems.forEach(x => {
      this.tdColumns.push(`${x.per}％`);
      this.tdColumns.push(`${x.count}人`);
      this.tdColumns.push(x.per);
    });
  }
}